import { c as _c } from "react/compiler-runtime";
import type React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { QRCode } from "@/components/ui/qr-code";
interface CouponQrDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  couponId: string;
  code?: string | null;
}
const CouponQrDialog: React.FC<CouponQrDialogProps> = t0 => {
  const $ = _c(19);
  const {
    open,
    onOpenChange,
    code
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("coupon.qrTitle");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <DialogTitle className="mb-2 text-center font-sans text-base font-normal">{t1}</DialogTitle>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = code ?? "";
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="flex justify-center"><QRCode value={t3} size={180} /></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("coupon.codeTitle");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== code || $[9] !== t5) {
    t6 = <div className="mt-0 text-center"><div className="text-muted-foreground text-xs font-normal">{t5}: {code}</div></div>;
    $[8] = code;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t4 || $[13] !== t6) {
    t7 = <DialogContent className="w-full max-w-xs px-4 pt-10 pb-4 md:px-5 md:pt-12 md:pb-5">{t2}{t4}{t6}</DialogContent>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== onOpenChange || $[16] !== open || $[17] !== t7) {
    t8 = <Dialog open={open} onOpenChange={onOpenChange}>{t7}</Dialog>;
    $[15] = onOpenChange;
    $[16] = open;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
export default CouponQrDialog;